import { render, staticRenderFns } from "./ArticleInfo.vue?vue&type=template&id=7d5a5f3f&"
import script from "./ArticleInfo.vue?vue&type=script&lang=js&"
export * from "./ArticleInfo.vue?vue&type=script&lang=js&"
import style0 from "./ArticleInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports